import React, { useEffect, useState } from 'react';
import NotificationService from '../../services/notifications/notificationService.js';
import { useLanguage } from '../../i18n/LanguageContext.jsx';
import { translateLegacyText } from '../../i18n/legacy/legacyLocalePacks.js';
import RawText from '../../i18n/RawText.jsx';
import { ReactComponent as IconCheck } from '../../NewIcon/IconCheck.svg';
import { ReactComponent as IconSemnulExclamarii } from '../../NewIcon/IconSemnulExclamarii.svg';
import { ReactComponent as IconX } from '../../NewIcon/IconX.svg';

const NotificationContainer = () => {
  const { activeLanguage } = useLanguage();
  const [notifications, setNotifications] = useState(() => (
    NotificationService.getQueue().filter((notification) => notification.overlay)
  ));

  useEffect(() => {
    const handleNotifications = (_notification, queue) => {
      setNotifications((queue || []).filter((item) => item.overlay));
    };
    NotificationService.onNotification(handleNotifications);
    return () => NotificationService.removeListener(handleNotifications);
  }, []);

  if (!notifications.length) return null;

  return (
    <div className="pointer-events-none fixed bottom-6 right-6 z-[120] flex w-[min(360px,calc(100vw-2rem))] flex-col gap-3">
      {notifications.map((notification) => {
        const isSuccess = notification.type === 'success';
        return (
          <div
            key={notification.id}
            className={`pointer-events-auto relative overflow-hidden rounded-2xl border bg-white p-4 pr-12 shadow-[10px_10px_28px_rgba(15,23,42,0.16),-8px_-8px_20px_rgba(255,255,255,0.95)] ${isSuccess ? 'border-emerald-200' : 'border-amber-200'}`}
            role="status"
          >
            <div className={`absolute inset-y-0 left-0 w-1 ${isSuccess ? 'bg-emerald-500' : 'bg-amber-400'}`} />
            <div className="flex items-start gap-3">
              <div className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-xl ring-1 ${isSuccess ? 'bg-emerald-50 text-emerald-600 ring-emerald-100' : 'bg-amber-50 ring-amber-100'}`}>
                {isSuccess
                  ? <IconCheck className="h-4 w-4" aria-hidden="true" />
                  : <IconSemnulExclamarii className="h-4 w-4" aria-hidden="true" />}
              </div>
              <div className="min-w-0 pt-0.5">
                <div className={`text-xs font-bold uppercase tracking-wider ${isSuccess ? 'text-emerald-700' : 'text-slate-500'}`}>
                  {isSuccess ? 'Succes' : 'Atenție'}
                </div>
                <div className={`mt-1 text-sm font-semibold leading-5 ${isSuccess ? 'text-emerald-600' : 'text-amber-600'}`}>
                  <RawText>
                    {notification.contentSource === 'backend'
                      ? notification.message
                      : translateLegacyText(activeLanguage, notification.message)}
                  </RawText>
                </div>
              </div>
            </div>
            <button
              type="button"
              onClick={() => NotificationService.remove(notification.id)}
              className="absolute right-3 top-3 flex h-8 w-8 items-center justify-center rounded-lg transition hover:bg-slate-100"
              aria-label="Închide notificarea"
            >
              <IconX className="h-3 w-3" />
            </button>
          </div>
        );
      })}
    </div>
  );
};

export default NotificationContainer;
